import {useEffect, useState} from 'react';


const Checkbox = (props) => {
    const {name, value, disabled, label, isReady, containerClass, onChange, ...rest} = props
    const [inputValue, setInputValue] = useState("off")


    useEffect(() => {
        if(value){
            setInputValue(value)
        }
    }, [value])


    const handleChange = (event) => {
        setInputValue(event.target.checked ? "on" : "off")
        if(typeof onChange === "function"){
            onChange(event)
        }
    }


    const checkDisabled = () => {
        return !isReady ? true : disabled
    }

    return (
        <div className={`Checkbox ${containerClass}`}>
            <div className="custom-control custom-switch">
                <input
                    name={name}
                    type="checkbox"
                    value={inputValue}
                    onChange={handleChange}
                    id={`custom_switch_${name}`}
                    checked={inputValue === "on"}
                    className="custom-control-input"
                    disabled={checkDisabled()}
                    {...rest}
                />
                <label className="custom-control-label" aria-disabled={disabled} htmlFor={`custom_switch_${name}`}>
                    {label ? label : ''}
                </label>
            </div>
        </div>
    )
}

export default Checkbox;